import React, {ChangeEventHandler, useCallback, useState} from 'react'
import {FieldRenderProps} from 'react-final-form'
import OutsideClickHandler from '../../containers/OutsideClickHandler'
import Tick from '../../../assets/icons/Tick.svg'
import styles from './TopSearchSelect.scss'
import { areaList, CURRENT_LOCATION, getPrefecture, Locale, prefectureList } from '../../../config/constants'
import { areaMessages } from '../../../config/commonMessages'
import { useIntl } from 'react-intl'

export enum TopSearchSelectType {
  category = 'category',
  car = 'car',
  station = 'station',
}

export const TopSearchSelect = (
  {
    input: {onChange, value},
    selectType,
    props,
    label,
    options,
    className,
    isBorder = true,
    locale = Locale.ja,
    onHover
  }: FieldRenderProps<string, HTMLSelectElement> & {
    selectType: TopSearchSelectType
    props: FieldRenderProps<Date, HTMLInputElement>
    onChange?: ChangeEventHandler<HTMLSelectElement>
    label: string
    options: Array<Record<'value' | 'text' | 'action', any>>
    className: string
    isBorder: boolean
    locale: Locale
    onHover?: (show?: boolean) => void
}) => {
  const localOnChange = useCallback(
    (select: string) => {
      onChange(select)
    },
    [onChange]
  )
  const intl = useIntl()
  const [show, setShow] = useState(false)
  const onClose = useCallback(() => {
    setShow(false)
    if (onHover) onHover(false)
  }, [])
  return <OutsideClickHandler
    onOutsideClick={onClose}
    onClick={() => {
      setShow(true)
    }}
    onMouseEnter={() => { if (onHover) onHover(true) }}
    onMouseLeave={() => { if (onHover) onHover(false) }}
    className={['position-relative h-100 c-pointer', className, styles.area].filter(Boolean).join(' ')}
  >
    <div className={[isBorder && 'border-right', 'mt-1', styles.border].filter(Boolean).join(' ')}>
      <div className={styles.searchTitle}>{label}</div>
      <div className={['font-weight-bold', styles.selectText].join(' ')}>
        {
          selectType === TopSearchSelectType.category
            ? value === TopSearchSelectType.station
              ? intl.formatMessage({ id: 'search.spotAndActivity' })
              : intl.formatMessage({ id: 'search.van' })
            : !value
              ? intl.formatMessage({ id: 'stationsSearch.allCountry' })
              : value === CURRENT_LOCATION
                ? intl.formatMessage({ id: 'stationsSearch.currentLocation' })
                : value === TopSearchSelectType.station
                  ? prefectureList.includes(value) && getPrefecture(Locale.ja, value)
                  : areaList.includes(value) ? intl.formatMessage({ ...areaMessages[value] }) : getPrefecture(locale, value)
        }
      </div>
    </div>
    {show && <div
        {...props}
        className={[styles.invisibleSelect, 'font-weight-bold position-absolute rounded-lg py-1'].join(' ')}
      >
        {options?.map(({ text, value: selectValue, action }, i) => {
          const selected = selectValue
          const isSelected = value === selectValue
          return <div
            key={i}
            className={['text-nowrap font-weight-normal pl-2 pr-3', styles.option].join(' ')}
            onClick={e => {
              e.stopPropagation()
              if (action) { action(e) }
              if (onHover) onHover(false)
              setShow(false)
              localOnChange(selected)
            }}
          >
            {isSelected ? <Tick
              className="fa font-size-11 mr-1"
            /> : '　'}{text}
          </div>
        })}
      </div>
    }
  </OutsideClickHandler>
}
